import { render, staticRenderFns } from "./ChevronUpRounded.vue?vue&type=template&id=9504fb22"
import script from "./ChevronUpRounded.vue?vue&type=script&lang=js"
export * from "./ChevronUpRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports